<template>
  <div>
    <LmListV2
      ref='LmMenuBuilderListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Menues',
      gqlField: 'MenuBuilder',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[MenuBuilderESSortEnum]) {
      MenuBuilder(
          titleList: "Menues"
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/menubuilder/editar/:id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/menubuilder/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]

          ) {
          count
          searcher
          tableItemsTotal
          titleList
          table {
            items {
              menuName,areas,subAreas,roles,createdAt,updatedAt,createdBy,updatedBy,published,deleted,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: ['menuName', 'areas', 'subAreas', 'roles', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'published', 'deleted', 'actions'],
      searchOnFieldsToSelected: ['menuName', 'areas', 'subAreas', 'roles', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'published', 'deleted', 'actions'],
      items: [
        {
          name: 'menuName'
        },
        {
          name: 'areas'
        },
        {
          name: 'subAreas'
        },
        {
          name: 'roles'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'published'
        },
        {
          name: 'deleted'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'menuName',
          label: 'Nombre',
          sortable: false
        },
        {
          key: 'areas',
          label: 'Áreas',
          sortable: true
        },
        {
          key: 'subAreas',
          label: 'Sub Áreas',
          sortable: true
        },
        {
          key: 'roles',
          label: 'Roles',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'createdBy',
          label: 'Creado por',
          sortable: true
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: true
        },
        {
          key: 'published',
          label: 'Publicado',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'En baja lógica',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
